import { render, staticRenderFns } from "./CompanyProfile1.vue?vue&type=template&id=82c0ccda&scoped=true&"
import script from "./CompanyProfile1.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile1.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile1.vue?vue&type=style&index=0&id=82c0ccda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c0ccda",
  null
  
)

export default component.exports